import { videoPostLink, videoSwiper } from './_video_swiper';
import { setCurvedEdgeHeights } from './_curves';

document.addEventListener('DOMContentLoaded', () => {
  videoSwiper();
  videoPostLink();
  setCurvedEdgeHeights();
});

window.addEventListener('resize', () => {
  const isOpenNav = document.querySelector('.tabs__nav--visible');
  const isButtonActive = document.querySelector('.tabs__button--active');

  if (window.innerWidth >= 1400 && isOpenNav && isButtonActive) {
    isOpenNav.classList.toggle('tabs__nav--visible');
    isButtonActive.classList.toggle('tabs__button--active');
  }
});
